<bp-hl-area-container name="Kurzprotokoll">
	<!-- Ohne graue Beschriftungsspalte (Nutzer-Auftrag 02.10.2026): Jedes Feld
	     traegt seine Beschriftung ueber sich, wie Hauptbodenform und Praefix.
	     Punktart und Pfeilrichtung sind eigene Bausteine ohne `label`; sie
	     bekommen dasselbe Markup wie die Felder der Bibliothek (form-group +
	     label), damit die Beschriftung gleich aussieht. -->
	<div class="touch-form">
		<!-- Gruppe 1: Punktart, Kartierer, Datum -->
		<div class="form-row">
			<div class="form-input-cell">
				<div class="form-group">
					<label>Punktart</label>
					<bp-punktart-picker *ngIf="!commenting" [type]="data.type" (typeChange)="onPunktartPicked($event)"></bp-punktart-picker>
					<wd-typeahead *ngIf="commenting" [(model)]="punktartModel" name="Punktart" [filter]="punktartFilter()"></wd-typeahead>
				</div>
			</div>
		</div>
		<div class="form-row" *ngIf="istPunktartDrehbar(data.type)">
			<div class="form-input-cell">
				<div class="form-group">
					<label>Pfeilrichtung</label>
					<bp-rotation-picker [type]="data.type" [rotation]="data.rotation" (rotationChange)="onRotationChanged($event)"></bp-rotation-picker>
				</div>
			</div>
		</div>
		<div class="form-row">
			<div class="form-input-cell">
				<wd-text-input *ngIf="canSeePersonalData()" name="Kartierer" label="Kartierer" [(model)]="data.header.aufnahme.kartierer" nonEmpty></wd-text-input>
				<div *ngIf="!canSeePersonalData()" class="form-group">
					<label>Kartierer</label>
					<span class="masked-value">–</span>
				</div>
			</div>
		</div>
		<div class="form-row">
			<div class="form-input-cell">
				<wd-date-input *ngIf="canSeePersonalData()" name="Aufnahmedatum" label="Aufnahmedatum" [(model)]="data.header.aufnahme.datum" nonEmpty></wd-date-input>
				<div *ngIf="!canSeePersonalData()" class="form-group">
					<label>Aufnahmedatum</label>
					<span class="masked-value">–</span>
				</div>
			</div>
		</div>

		<!-- Gruppe 2: Adresse -->
		<div class="form-section-header">Adresse</div>
		<div class="form-row">
			<div class="form-input-cell multi">
				<wd-typeahead [(model)]="data.header.forstamt" name="Forstamt" label="Forstamt"></wd-typeahead>
				<span class="inline-label">/</span>
				<wd-typeahead [(model)]="data.header.revier" name="Revier" label="Revier"></wd-typeahead>
			</div>
		</div>
		<div class="form-row">
			<div class="form-input-cell multi">
				<wd-text-input name="Abteilung" label="Abteilung" [(model)]="data.header.adresse.abteilung"></wd-text-input>
				<wd-typeahead [(model)]="data.header.adresse.unterabteilung" name="Unterabteilung" label="Unterabteilung"></wd-typeahead>
				<wd-text-input name="Teilfläche" label="Teilfläche" [(model)]="data.header.adresse.teilflaeche"></wd-text-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-input-cell multi">
				<wd-text-input name="Gemarkung" label="Gemarkung" [(model)]="data.header.adresse.gemarkung"></wd-text-input>
				<wd-number-input name="Flur" label="Flur" [(model)]="data.header.adresse.flur"></wd-number-input>
				<wd-text-input name="Flurstück" label="Flurstück" [(model)]="data.header.adresse.flurstueck"></wd-text-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-input-cell">
				<wd-text-input name="Forstbetrieb" label="Forstbetrieb" [(model)]="data.header.forstbetrieb"></wd-text-input>
			</div>
		</div>

		<!-- Gruppe 3: Befund -->
		<div class="form-section-header">Befund</div>
		<!-- Bodenform wie im Reiter „Boden" (Nutzer-Entscheidung 02.10.2026): je Glied
		     ein Block, Hauptbodenform oben, Präfix und Feinbodenform darunter. Vorher
		     standen Präfix, Feinbodenform, Suffix, (G), beide Wasserformen und das
		     Mesoklima in EINER Zeile, und die Feinbodenform bekam kaum Platz.
		     Wie dort OHNE Beschriftungsspalte: Jedes Feld traegt seine Beschriftung
		     selbst, und die Spalte kostete am Tablet hochkant jedem Glied rund
		     65 Pixel (im Bild nachgemessen 02.10.2026).
		     Der Weg in den Bodenformen-Katalog ist der Knopf im HBF-Feld, je Glied
		     (Nutzer-Entscheidung 28.09.2026; vorher ein (i) an der Beschriftung). -->
		<div class="form-row">
			<div class="form-input-cell multi bodenform-row">
				<ng-container *ngFor="let bf of data.header.bodenform.bf; let i = index; trackBy: trackByIndex">
					<wd-list-input *ngIf="i > 0" class="bodenform-trenner" name="BodenformTrenner" options="/|//" [(model)]="bf.trenner"></wd-list-input>
					<div class="bodenform-pair">
						<wd-typeahead [(model)]="bf.hbf" label="Hauptbodenform" name="Hauptbodenform[i]" [filter]="hauptbodenformFilter(data.type, i)" placement="bottom" [acceptOtherValues]="true" [extraSuggestions]="moorHBFSuggestions" [focusFirst]="false">
							<button feldKnopf type="button" class="btn btn-outline-secondary feld-knopf" title="Im Bodenformenkatalog nachschlagen" aria-label="Im Bodenformenkatalog nachschlagen" (click)="nachschlagen.zeigeSteckbrief(bf.hbf)"><i class="bi bi-journal-text"></i></button>
						</wd-typeahead>
						<div class="bodenform-fbf-line">
							<wd-text-input class="prefix-narrow" [(model)]="bf.prefix" label="Präfix" name="FBFPrefix[i]"></wd-text-input>
							<wd-typeahead #fbfFeld [(model)]="bf.fbf" label="Feinbodenform" name="Feinbodenform[i]" [filter]="feinbodenformFilter(bf.hbf)" [hbfFilter]="bf.hbf" placement="bottom" (hbfSelected)="bf.hbf = $event" [hbfAusFreitext]="hbfAusMoorFbf" [acceptOtherValues]="true" [otherValuesRegex]="moorFBFRegex" [otherValuesRegexMessage]="moorFBFRegexMessage" [extraSuggestions]="moorFBFSuggestionsFor(bf.hbf)" [focusFirst]="false">
								<button feldKnopf type="button" class="btn btn-outline-secondary feld-knopf" title="Feinbodenform aus der Liste wählen" aria-label="Feinbodenform aus der Liste wählen" (click)="nachschlagen.waehleFeinbodenform(fbfFeld, bf.fbf, bf.hbf)"><i class="bi bi-list-ul"></i></button>
							</wd-typeahead>
						</div>
					</div>
				</ng-container>
				<div class="btn-group bodenform-buttons">
					<button *ngIf="data.header.bodenform.bf.length > 1" class="btn btn-danger btn-sm" (click)="removeFeinbodenform()"><i class="bi bi-trash"></i></button>
					<button *ngIf="canAddFeinbodenform()" class="btn btn-info btn-sm" (click)="addFeinbodenform()"><i class="bi bi-plus"></i></button>
				</div>
				<wd-typeahead class="bodenform-suffix" [(model)]="data.header.bodenform.suffix" label="Suffix" name="BodenformSuffix" placement="bottom" [acceptOtherValues]="true"></wd-typeahead>
				<wd-checkbox-input *ngIf="reliktGInteractive(); else reliktGLockedTpl" class="narrow" name="ReliktG" label="(G)" [(model)]="data.header.bodenform.reliktG"></wd-checkbox-input>
				<ng-template #reliktGLockedTpl>
					<wd-checkbox-input class="narrow reliktg-locked" name="ReliktG" label="(G)" [model]="false" title="(G) nur bei anhydromorpher Hauptbodenform aktivierbar"></wd-checkbox-input>
				</ng-template>
			</div>
		</div>
		<!-- Wasserformen und Mesoklima: eigene Zeile, seit die Bodenform wie im
		     Reiter „Boden" steht (02.10.2026). -->
		<div class="form-row">
			<div class="form-input-cell multi">
				<wd-text-input name="Wasserform2" label="Stauwasserform" [(model)]="data.header.wasserstufe2" [superscript]="true"></wd-text-input>
				<span class="inline-label">/</span>
				<wd-text-input name="Wasserform" label="Grundwasserform" [(model)]="data.header.wasserstufe" [superscript]="true"></wd-text-input>
				<wd-list-input name="Mesoklima" label="Mesoklima" [(model)]="data.extendedHeader.mesoklima"></wd-list-input>
			</div>
		</div>
		<!-- Das Feld ist allein die Humusform (Liste „Humusformen"); die alte
		     Beschriftungsspalte hiess „Humusf./Veg.FG". -->
		<div class="form-row">
			<div class="form-input-cell">
				<wd-typeahead name="HumusformNeu" label="Humusform" [(model)]="data.header.humusform.aufnahmeFlaeche.neu" [acceptOtherValues]="true"></wd-typeahead>
			</div>
		</div>
		<!-- Kalktiefe und Spiegeltiefe nur bei Infopunkt, Halbtiefbohrung und
		     Grenzaufschluss ohne Protokoll (Nutzer-Auftrag 24.09.2026) - dieselben
		     Felder wie in der Boden-Maske des vollen Protokolls. -->
		<div class="form-row" *ngIf="istPunktartMitKalkSpiegeltiefe(data.type)">
			<div class="form-input-cell multi">
				<wd-number-input name="Kalktiefe" label="Kalktiefe [cm]" [(model)]="data.extendedHeader.karbonat"></wd-number-input>
				<!-- Unter oder über Flur: Knopf im Feld, über Flur negativ gespeichert; bei Filz
				     zählt Flur ab Oberkante Ol (flur-tiefe.ts). -->
				<bp-flur-tiefe-input name="Spiegeltiefe" label="Spiegeltiefe [cm]" [(model)]="data.extendedHeader.spiegelTiefe" [versatz]="filzVersatz()"></bp-flur-tiefe-input>
			</div>
		</div>
		<!-- Ab wo gemessen wird: immer ab Oberkante Mineralboden. Bei einem Filz
		     rechnen Uebersicht, PDF und Export die Auflage dazu (filz-tiefen.ts). -->
		<div class="form-row" *ngIf="istPunktartMitKalkSpiegeltiefe(data.type)">
			<div class="form-input-cell text-muted small tiefen-hinweis">{{ tiefenHinweis() }}</div>
		</div>

		<!-- Gruppe 4: Bemerkungen - ohne graue Beschriftungsspalte, das Wort steht
		     schon in der Ueberschrift darueber (Nutzer-Entscheidung 11.09.2026,
		     genauso im Reiter „Boden"). -->
		<div class="form-section-header">Bemerkungen</div>
		<div class="form-row">
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bemerkungen" [(model)]="data.header.bemerkungen"></wd-multiline-text-input>
			</div>
		</div>
	</div>
</bp-hl-area-container>
